import { defineStore } from 'pinia'
import { EaseChatSDK, EaseChatClient } from '@/IM/initwebsdk'
import imuserApi from '@/api/onlineChat/imuserApi'
/**
 * 环信IM会话
 */
export const useImConversationStore = defineStore({
	id: 'imConversation',
	state: () => ({
		// 会话列表
		conversationList: [],
		// 用户属性
		userAttribute: {}
	}),
	actions: {
		// 获取会话列表
		getConversationList(cursor = '') {
			EaseChatClient.getServerConversations({ pageSize: 50, cursor }).then((res) => {
				this.conversationList = res.data.conversations
				const ids = this.conversationList.map((i) => i.conversationId)
				imuserApi
					.imUserInfoByIds({ idList: ids, userType: parseInt(localStorage.getItem('currentUserType')) == 2 ? 1 : 2 })
					.then((res1) => {
						this.userAttribute = res1
					})
				// EaseChatClient.fetchUserInfoById(ids).then((res) => {
				//     this.userAttribute = res.data
				// })
			})
		},
		// 清空会话列表未读数量
		clearUnReadCount(to) {
			// 乐观更新：立即将本地未读数清零，避免 UI 延迟
			const target = this.conversationList.find((i) => i.conversationId === to)
			if (target) target.unReadCount = 0
			const option = { chatType: 'singleChat', type: 'channel', to }
			const msgBody = EaseChatSDK.message.create(option)
			EaseChatClient.send(msgBody).then(() => {
				setTimeout(() => this.getConversationList(), 500)
			})
		}
	}
})
